import App from './components/App.svelte';

const app = new App({
	target: document.getElementById('product-viewer'),
	props: {
		images: window.productImageList || []
	}
});

export default app;
